// extracted by mini-css-extract-plugin
module.exports = {"label":"select_label__Hhoy6 font-bold inline-block mr-2","content":"select_content__qPNPB inline-block","contentHtml":"select_contentHtml__JrMPC inline-block"};